import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import ContactForm from '../components/home/ContactForm';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us | Florida's Top Site Service & Demolition</title>
        <meta name="description" content="Get in touch with our demolition and site clearing experts. Request a free quote for your residential or commercial project." />
      </Helmet>
      
      <PageHeader>
        <div className="container">
          <h1 className="animate-on-scroll slide-down">Contact Us</h1>
          <p className="animate-on-scroll slide-up delay-200">Get in touch for a free quote or to discuss your project</p>
        </div>
      </PageHeader>
      
      <ContactForm />
    </>
  );
};

const PageHeader = styled.section`
  background-color: var(--primary-color);
  color: white;
  padding: 12rem 0 6rem;
  text-align: center;
  
  h1 {
    color: white;
    font-size: 4.8rem;
    margin-bottom: 1.5rem;
  }
  
  p {
    font-size: 2rem;
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    padding: 10rem 0 5rem;
    
    h1 {
      font-size: 3.6rem;
    }
    
    p {
      font-size: 1.8rem;
    }
  }
`;

export default Contact; 